module.exports = __webpack_public_path__ + "media/images/logo-0c8cb4c5b7aa2b45b059b19b9a1fb5ae.jpg";